import { jsx as _jsx } from "react/jsx-runtime";
import { Spin } from 'antd';
export const Loading = ({ isLoading, pastDelay, timedOut, error, retry, ...reset }) => (_jsx("div", { style: { paddingTop: 100, textAlign: 'center' }, children: _jsx(Spin, { size: "large", ...reset }) }));
